export default "__VITE_ASSET__CdjSnl$M__"